exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset.scheduler-border {\r\n  border: 1px solid #D4D4D4 !important;\r\n  padding: 0 1.4em 1.4em 1.4em !important;\r\n  margin: 0 0 1.5em 0 !important;\r\n  box-shadow:  0px 0px 0px 0px #000;\r\n}\r\n\r\nfieldset.scheduler-border.editando {\r\n  border: 1px dashed #D4D4D4 !important;;\r\n}\r\n\r\nlegend.scheduler-border {\r\n  font-size: 1.2em !important;\r\n  text-align: left !important;\r\n  width:auto;\r\n  padding:0 10px;\r\n  border-bottom:none;\r\n}\r\n.searcher{\r\n  opacity: 0.5;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/selectorMultiple/selectorMultiple.css
// module id = ../../../../../src/app/helpers/components/selectorMultiple/selectorMultiple.css
// module chunks = main